import { render, staticRenderFns } from "./AddDomain.vue?vue&type=template&id=12fe1548&scoped=true"
import script from "./AddDomain.vue?vue&type=script&lang=js"
export * from "./AddDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe1548",
  null
  
)

export default component.exports